module.exports = __webpack_public_path__ + "img/Mb_MiddleSide_Left.0cb30617.jpg";